const CVENT_REGEX = /(cvent|cvt)/i;
const CVENT_ACCOUNT_NAME_REGEX = /^CVT/;
const CVENT_EMAIL_REGEX = /@(crowdcompass.com|cvent.comx|cvent.com|growthrocks.com|j.mail|no.com|no.mail|socialtables.com)$/i;
/**
 * A user is considered a cvent employee if either of the following are true:
 *   1. They have a cvent email address
 *   2. The company name if sent contains cvent
 *   3. The account Name starts with internal account prefix
 * @param trait
 * @returns
 */
export function isCventEmployee(trait) {
    if (
    // if they have a cvent email address
    trait.email?.match(CVENT_EMAIL_REGEX) ||
        // If company has cvent or cvt (case insensitive in the name)
        trait.company?.match(CVENT_REGEX) ||
        // the account Name starts with internal account prefix
        trait.accountNumber?.match(CVENT_ACCOUNT_NAME_REGEX)) {
        return true;
    }
    return false;
}
//# sourceMappingURL=isCventEmployee.js.map